export default __webpack_public_path__ + "static/media/serv-05.6c33f78e.jpg";